"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var typestyle_1 = require("typestyle");
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var Info_1 = require("../../gen-src/icons/Info");
var Localize_1 = require("../../gen-src/Localize");
function renderFileType(connectionType) {
    var helpText = getHelpTextForFile(connectionType);
    var friendlyConnectionTypeName = data_catalog_shared_1.messageForConnectionType(connectionType);
    return renderAboutFileTextDetailItem(Localize_1.Messages.FileType(), friendlyConnectionTypeName, helpText);
}
exports.renderFileType = renderFileType;
// This is based off of the ConnectToAllowedClasses, will need to manually add new types from that which need this messaging
function getHelpTextForFile(connectionType) {
    switch (connectionType) {
        case 'csv':
        case 'cloudfile:box-semistructpassivestore-direct':
        case 'cloudfile:box-textscan':
        case 'cloudfile:dropbox-semistructpassivestore-direct':
        case 'cloudfile:dropbox-textscan':
        case 'cloudfile:googledrive-semistructpassivestore-direct':
        case 'cloudfile:googledrive-textscan':
        case 'cloudfile:onedrive-semistructpassivestore-direct':
        case 'cloudfile:onedrive-textscan':
        case 'dataengine':
        case 'textclean':
        case 'textscan':
        case 'textscan-reader':
            return Localize_1.Messages.FileSingleTable();
        case 'cloudfile:box-excel-direct':
        case 'cloudfile:dropbox-excel-direct':
        case 'cloudfile:googledrive-excel-direct':
        case 'cloudfile:onedrive-excel-direct':
        case 'excel':
        case 'excel-direct':
        case 'excel-reader':
        case 'google-sheets':
        case 'hyper':
        case 'msaccess':
            return Localize_1.Messages.FileMultipleTables();
        default:
            return '';
    }
}
function renderAboutHeaderTextDetailItem(label, value, testId) {
    return (React.createElement("div", { className: data_catalog_shared_1.aboutHeaderDetailItem, key: testId },
        React.createElement(data_catalog_shared_1.VerticalFlexContainer, { fillFlexParent: true },
            React.createElement("div", { className: data_catalog_shared_1.aboutHeaderDetailLabel }, label),
            React.createElement("span", { "data-tb-test-id": testId, title: value, className: data_catalog_shared_1.aboutHeaderDetailsTextElide }, value))));
}
exports.renderAboutHeaderTextDetailItem = renderAboutHeaderTextDetailItem;
function renderEmbeddedAssetDescription(testId) {
    return renderTextDetailItem(Localize_1.Messages.DatabaseCategory(), Localize_1.Messages.EmbeddedAsset(), Localize_1.Messages.EmbeddedAssetHelpText(), testId);
}
exports.renderEmbeddedAssetDescription = renderEmbeddedAssetDescription;
function renderAboutFileTextDetailItem(label, value, helpText) {
    return renderTextDetailItem(label, value, helpText, 'table-details-connection-type-test-id');
}
function renderTextDetailItem(label, value, helpText, testId) {
    return (React.createElement("div", { className: typestyle_1.classes(data_catalog_shared_1.aboutHeaderDetailItem, data_catalog_shared_1.aboutHeaderConnectionTypeDetailItem), key: testId },
        React.createElement(data_catalog_shared_1.VerticalFlexContainer, { fillFlexParent: true },
            React.createElement("div", { className: data_catalog_shared_1.aboutHeaderDetailLabel }, label),
            React.createElement(data_catalog_shared_1.HorizontalFlexContainer, { fillFlexParent: true },
                React.createElement("div", { "data-tb-test-id": testId, title: value, className: data_catalog_shared_1.aboutHeaderConnectionTypeDetailText }, value),
                React.createElement("div", { title: helpText, className: data_catalog_shared_1.aboutHeaderConnectionTypeDetailIcon },
                    React.createElement(Info_1.SvgInfo, { className: data_catalog_shared_1.aboutHeaderInfoIcon }))))));
}
function AboutHeaderDescriptionDetailItem(props) {
    var markupEditingEnabled = React.useContext(data_catalog_shared_1.FeatureFlagsContext).markupEditingEnabled;
    var description = props.description, testId = props.testId;
    var markup = (markupEditingEnabled ? React.createElement(data_catalog_shared_1.FormattedMarkupWrapperInPage, { markup: description }) : description);
    var fallback = (React.createElement("div", { className: data_catalog_shared_1.aboutHeaderPlaceholderText }, Localize_1.Messages.NoDescriptionAvailable()));
    return (React.createElement("div", { className: data_catalog_shared_1.aboutHeaderDescriptionAndTags },
        React.createElement("div", { className: data_catalog_shared_1.aboutHeaderDetailLabel }, Localize_1.Messages.Description()),
        React.createElement("div", { className: data_catalog_shared_1.aboutHeaderDescriptionAndTagsContent, "data-tb-test-id": testId }, description ? markup : fallback)));
}
exports.AboutHeaderDescriptionDetailItem = AboutHeaderDescriptionDetailItem;
function renderAboutHeaderTagsDetailList(tags, testId, urls, contentType) {
    // filters out null names in tags list
    var filtered = data_catalog_shared_1.filterOutNullAndUndefined(tags.map(function (t) { return t.name; }));
    return (React.createElement("div", { className: data_catalog_shared_1.aboutHeaderDescriptionAndTags },
        React.createElement("div", { className: data_catalog_shared_1.aboutHeaderDetailLabel }, Localize_1.Messages.Tags()),
        React.createElement("div", { className: data_catalog_shared_1.aboutHeaderDescriptionAndTagsContent, "data-tb-test-id": testId }, tags.length === 0 ?
            React.createElement("div", { className: data_catalog_shared_1.aboutHeaderPlaceholderText }, Localize_1.Messages.NoTagsAvailable()) :
            filtered.map(function (name, index) { return (React.createElement(React.Fragment, { key: name },
                React.createElement(react_router_dom_1.Link, { to: contentType === 'DatabaseTable' ? urls.catalogTablesWithTagPath(name) :
                        urls.catalogDatabasesWithTagPath(name), title: name, className: data_catalog_shared_1.linkClass }, name),
                (tags.length - index) > 1 ? Localize_1.Messages.Comma() : null)); }))));
}
exports.renderAboutHeaderTagsDetailList = renderAboutHeaderTagsDetailList;
function renderAboutHeaderDatabaseNameLinkItem(label, databaseName, databaseId, testId, urls) {
    return (React.createElement("div", { className: data_catalog_shared_1.aboutHeaderDetailItem, key: testId },
        React.createElement(data_catalog_shared_1.VerticalFlexContainer, { fillFlexParent: true },
            React.createElement("div", { className: data_catalog_shared_1.aboutHeaderDetailLabel }, label),
            React.createElement(react_router_dom_1.Link, { to: urls.catalogDatabasePath(databaseId), title: databaseName, className: data_catalog_shared_1.aboutHeaderDetailsTextElide, "data-tb-test-id": testId }, databaseName))));
}
exports.renderAboutHeaderDatabaseNameLinkItem = renderAboutHeaderDatabaseNameLinkItem;
//# sourceMappingURL=AboutHeaderDetailItems.js.map